export const NAMESPACE = "PortalDescription";

export const MAX_LIMIT_OF_CHARACTERS = 550;
